import { Space, Select, Table, message, Spin, Tooltip, Button, Divider, Popconfirm, Modal, Typography, Checkbox, Result, Card, Image, List, Input, Form, Radio, InputNumber } from 'antd';
import { DeleteOutlined, InfoCircleOutlined, BulbOutlined, UnorderedListOutlined, DollarOutlined, CheckOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import { CommonContext, CurrencyContext } from '../../Context';
import { getCurrencyName } from '../../globalFunctions/GlobalFunctions';
const { Option } = Select
const JobBoardBasketView = (props) => {

	//Variable declaration
	const [loader, setLoader] = useState(false);
	const [jobsCount, setJobsCount] = useState(0);
	const [priorityCheck, setPriorityCheck] = useState("f");
	const [jobBasketData, setJobBasketData] = useState([]);
	const [jobBasketSupplierList, setJobBasketSupplierList] = useState([]);
	const [showBoostProductBuy, setShowBoostProductBuy] = useState(false);
	const [termsChecked, setTermsChecked] = useState(false);
	// const [recommendTableShow,setRecommendTableShow]=useState(true);
	const [expandedRowKeys, setExpandedRowKeys] = useState([]);
	const [selectedJobList,setSelectedJobList] = useState([]);
	const [selectedTotal,setSelectedTotal]=useState(0);
	const [currencValue,setCurrencyValue]=useState();
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [reload,setReload]=useState(false);
	const [visibleCounts, setVisibleCounts] = useState({}); // State to manage visible items
	const [supplierSelectedList,setSupplierSelectedList]=useState([]);
	const currencyContext=useContext(CurrencyContext);
	const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
	const [linkedInBoost,setLinkedInBoost] = useState(null);
	const [formCreate] = Form.useForm();
	const [formCreateLinkedIn] = Form.useForm();
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const options = Array.from({ length: 20 }, (_, i) => (i + 1) * 500);
	const optionsFree = Array.from({ length: 20 }, (_, i) => (i + 1) * 50);
  const [isHIAdmin,setIsHIAdmin]=useState(false);
  const [paymentType, setPaymentType] = useState(null); // Default payment type
  const isSelfService = sessionStorage.getItem('isSelfService');
  const AllowCreditInvoicing = sessionStorage.getItem('allowCreditInvoicing');
  const [purchaseLoader,setPurchaseLoader]=useState(false);
	const [linkedInUrl,setLinkedInUrl]=useState(null);
	const [isCreditInvoiceModalOpen, setIsCreditInvoiceModalOpen] = useState(false);
	const [creditInvoiceForm] = Form.useForm();
	const [countryList, setCountryList] = useState([]);
  const [countryLoader, setCountryLoader] = useState(false);
	const [hasSubmittedCreditInvoice, setHasSubmittedCreditInvoice] = useState(false);
	const [showCreditInvoiceSuccessMessage, setShowCreditInvoiceSuccessMessage] = useState(false);
	const [openTopupAfterCreditInvoiceClose, setOpenTopupAfterCreditInvoiceClose] = useState(false);

	// Table columns
	const boostJobsBuyColumns = [
		{
			title: 'Job',
			dataIndex: 'title',
			key: 'title',
			render: (text,record) =>
			(<>
				<p className='whitespace-nowrap'>{text}</p>
				<span className='font-semibold text-gray-400'>{record.name}</span></>
			)
		},
		{
			title: 'Location',
			dataIndex: 'place',
			key: 'place',
		},
		{
			title: 'Days',
			dataIndex: 'postingDurationDays',
			key: 'postingDurationDays',
			render: (text,record) =>
			(
				record?.customercontracts?.length>0?
				<span className='whitespace-nowrap'>-</span>:
				<span className='whitespace-nowrap'>{text} Days</span>
			)
		},
		{
			title: 'Price',
			dataIndex: 'buyerPrice',
			key: 'buyerPrice',
			render: (text,record) =>
			(
				record?.customercontracts?.length>0?
				<span className='whitespace-nowrap'>{record?.priceCurrencySymbol} 0</span>:
				<span className='whitespace-nowrap'>{record?.priceCurrencySymbol} {text}</span>
			)
		},
		{
			title: 'Actions',
			key: 'action',
			align: 'center',
			render: (_, record) =>
				<Tooltip title="Delete" placement='bottom'>
					<Popconfirm title="Sure you want to delete?" onConfirm={()=>DeleteBuyProduct(record)} placement="left">
						<Button icon={<DeleteOutlined />} type="link" size='large' />
					</Popconfirm>
				</Tooltip>
		}
	];
	//On load function call
	useEffect(() => {
		getBuyerPrioritylist();
		jobBoardBoostsBasketList();
		jobBoardBoostsSupplierList();
		fetchCountryList();
	}, []);
	useEffect(() => {
		
	}, [reload]);
	useEffect(() => {
    const isAdmin = Cookies.get(constants.COOKIE_IS_ADMIN);
    setIsHIAdmin(isAdmin==="true"?"true":"false");
    //setIsHIAdmin("false")
  }, []);
	//Functions
	//Function to get job bost basket listing.
	const jobBoardBoostsBasketList = async (recommend=true) => {
		setLoader(true);
		let url;
		let payload=null;
		if(recommend)
		{
			if(sessionStorage.getItem('selectedissubbuyeradmin')?.toString() === 'true'){
      	url = WebLinks.GetJobBoardBoostsSubBuyerViewRecommendListing ;
			}else{
				url = WebLinks.GetJobBoardBoostsViewRecommendListing ;
			}
			payload={
					buyerId:buyerId,
					channelId:supplierSelectedList
		}
		}else{
			url = WebLinks.GetJobBoardBoostsViewListing + buyerId;
		}
		const response = await APIUtils.apiCall(recommend?'POST':'GET', url,payload?JSON.stringify(payload):null);
		if (!response.isCatch && response.resultObj && response.resultObj.statusCode!=="2400") {
			response.resultObj.data.map((item,index)=>{
				item.id=item.jobId+"j"+index
			})
			setJobBasketData(response.resultObj.data);
			setExpandedRowKeys(response.resultObj.data.map(item => item.id));
			setJobsCount(response.resultObj?.getCount);
			setLinkedInBoost(response.resultObj?.linkedInBoostExist?.toString());
			setLinkedInUrl(response.resultObj?.linkedinCompanyURL||null);
			setLoader(false);
		} else {
			setJobBasketData([]);
			setLinkedInUrl(null);
			setLinkedInBoost(false);
			setJobsCount(0);
			message.error(response?.resultObj?.message);
			setLoader(false);
		}
	};

    //Country list
  const fetchCountryList = async () => {
      setCountryLoader(true)
      const response = await APIUtils.apiCall("GET", WebLinks.GetCountryList);
      if (!response.isCatch) {
        setCountryList(response.resultObj.data)
      } else {
        message.error(response.resultObj.message);
      }
      setCountryLoader(false);
  }
	const jobBoardBoostsSupplierList = async () => {
		// setLoader(true);
		let url;
		url = WebLinks.GetJobBoardBoostSupplierList + buyerId;
		const response = await APIUtils.apiCall('GET', url);
		if (!response.isCatch && response.resultObj) {
			setJobBasketSupplierList(response.resultObj.data);
		} else {
			setJobBasketSupplierList([])
			message.error(response?.resultObj?.message);
		}
		// setLoader(false);
	};
	//Function to get priority list
	const getBuyerPrioritylist = async () => {
		let url = WebLinks.GetBuyerPriorityFilters + buyerId;
		const response = await APIUtils.apiCall('GET', url);
		if (!response.isCatch && response.resultObj) {
			setPriorityCheck(response?.resultObj?.data?.length > 5 ? "t" : "f");
		} else {
			message.error(response?.resultObj?.message);
		}
	};
	// Table columns
	const yourJobsBasketColumns = [
		{
			title: 'id',
			dataIndex: 'id',
			key: 'id',
			hidden: true
		},
		{
			title: 'Priority',
			key: 'priority',
			dataIndex: 'priority',
			sorter: (a, b) => a.priority - b.priority,
			render: (_, record) => (
				<Select
					disabled={true}
					//onChange={(e) => singlePriorityChange(e, record.id)}
					value={record.priority}
					className='w-14 select-readonly'
					options={priorityCheck === "t" ? constants.PriorityConstantList2 : constants.PriorityConstantList1}
				/>
			),
		},
		{
			title: 'Job Title',
			dataIndex: 'title',
			key: 'jobTitle',
			sorter: (a, b) => a.title.localeCompare(b.title),
		},
		{
			title: 'Reference',
			dataIndex: 'reference',
			key: 'reference',
			sorter: (a, b) => {
				const referenceA = parseInt(a.reference.match(/\d+/)[0], 10);
				const referenceB = parseInt(b.reference.match(/\d+/)[0], 10);
				return referenceA - referenceB;
			},
		},
		{
			title: 'Location',
			dataIndex: 'place',
			key: 'place',
			sorter: (a, b) => a.place.localeCompare(b.place),
		},
		Table.SELECTION_COLUMN,
		{
			title: 'Select Products',
			key: 'action',
			align: 'center',
			render: (_, record) => (
				<Space>

				</Space>
			),
		},
		{
			title: 'Actions',
			key: 'action',
			align: 'center',
			render: (_, record) => (
				<Space>
					<Popconfirm
						title="Remove Job"
						description="Are you sure to remove this job from basket?"
						onConfirm={() => confirm(record.jobId)}
						onCancel={cancel}
						okText="Yes"
						cancelText="No"
					>
						<Tooltip title="Remove job from basket" zIndex='1000'>
							<Button size='small' icon={<DeleteOutlined />} type="link" danger />
						</Tooltip>
					</Popconfirm>
				</Space>
			),
		}
	];
	const cancel = (e) => {
	};

	//Function to delete job
	const confirm = async (jobId) => {
		const jobDeleteResponse = await APIUtils.apiCall("DELETE", WebLinks.DeleteJobBoardBasketJob + buyerId + "&jobId=" + jobId);
		if (!jobDeleteResponse.isCatch) {
			message.success(jobDeleteResponse.resultObj.message)
			jobBoardBoostsBasketList();
		} else {
			message.error(jobDeleteResponse.resultObj.message);
		}
	};

	//Book Jobs function
	const BookJobsNow = async () => {
    let payload = null;
    payload = {
        selectedJobList
    };
    const jobBookResponse = await APIUtils.apiCall("POST", WebLinks.AddSelectedRecommendedJobs + buyerId, JSON.stringify(selectedJobList));
    if (!jobBookResponse.isCatch) {
				commonContext.changeCommonValues({'boostCredits':jobBookResponse?.resultObj?.boostCredits||0});
        const modal = Modal.info({
            width: 650,
            icon: null,
            footer: null,
            content: (
                <Result
                    status="success"
                    title="Thanks for placing this order."
                    subTitle={
                        <div>
                            <p>We are now processing it.</p>
                            <p>You can view the status of the order in the Boost Orders page.</p>
                            <p>All jobs included in this order have been removed from your shopping basket.</p>
                            <p>If you wish to Boost them to other boards you can add them back in and create an additional order.</p>
                        </div>
                    }
                    extra={
                        <Button type="primary" onClick={() => {
                            modal.destroy();
                            handleCancel();
                            props.handleCancelParent();
                        }}>
                            OK
                        </Button>
                    }
                />
            )
        });
    } else {
        message.error(jobBookResponse.resultObj.message);
    }
};

	//Open  buy modal
	const openBuyModal = () => {
		setShowBoostProductBuy(true);
		formCreateLinkedIn.setFieldsValue({
			linkedURL:linkedInUrl||null
		});
	}

	//Close buy modal
	const handleCancel = () => {
		formCreateLinkedIn.resetFields();
		setShowBoostProductBuy(false);
	};

	//Buy Products summary
	const BuyProductsSummary = () => {
		return (
			<>
				<Table.Summary.Row className='bg-teal-50'>
					<Table.Summary.Cell index={0}><strong>Total</strong></Table.Summary.Cell>
					<Table.Summary.Cell index={1} className='text-center'>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={2} className='text-center'>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={3}></Table.Summary.Cell>
					<Table.Summary.Cell index={4}>{currencValue} {selectedTotal}</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		)
	};

	//on Product selected
	const onProductSelected=(e,record,selectedrecord)=>{
		const checked = e.target.checked;
		setJobBasketData(prev =>
			prev.map(job => {
				if (job.id !== record.id) return job;
				return {
					...job,
					jobRecommendations: job.jobRecommendations.map(rec =>
						rec.key === selectedrecord.key
							? { ...rec, checked }
							: rec
					)
				};
			})
		);
		setSelectedJobList(prev => {
			let updated = [...prev];
			if (checked) {
				const alreadyExists = updated.some(
					item =>
						item.key === selectedrecord.key &&
						item.jobId === selectedrecord.jobId
				);
				if (!alreadyExists) {
					updated.push({
						...selectedrecord,
						checked: true,
						title: `${record.title} ${record.reference}`,
						id: record.id,
						buyerId: buyerId,
						place: record.place,
					});
				}
			} else {
				updated = updated.filter(
					item =>
						!(
							item.key === selectedrecord.key &&
							item.jobId === selectedrecord.jobId
						)
				);
			}
			const hasSelectedProducts = updated.some(
				item => item.id === record.id
			);
			setSelectedRowKeys(prevKeys => {
				if (hasSelectedProducts) {
					return prevKeys.includes(record.id)
						? prevKeys
						: [...prevKeys, record.id];
				}
				return prevKeys.filter(id => id !== record.id);
			});
			const total = updated.reduce((sum, item) => {
				if (!(item?.customercontracts?.length>0)) {
					return sum + (item?.buyerPrice || 0);
				}
				return sum;
			}, 0);
			setSelectedTotal(total);
			const hasLinkedInItem = updated.some(
				item => item.header?.toLowerCase().includes('linkedin boost')
			);
			setLinkedInBoost(hasLinkedInItem.toString());
			return updated;
		});
	};

	//Expanded list
	const expandedRowRender = (record) => {
		const handleLoadMore = () => {
			setVisibleCounts((prev) => ({
				...prev,
				[record.id]: record?.jobRecommendations?.length, // Update only this row's count
			}));
		};

		const visibleCount = visibleCounts[record.id] || 5; // Default to showing 5 items

		const loadMore =
			record?.jobRecommendations?.length > visibleCount && (
				<div className="flex justify-end">
					<Space size="small">
						<span>{`${record.jobRecommendations.length} products`}</span>
						<Button type="link" onClick={handleLoadMore}>
							Show all
						</Button>
					</Space>
				</div>
			);

		return (
			<>
				<List
					grid={{ gutter: 8, column: 5 }}
					//dataSource={record?.jobRecommendations?.slice(0, visibleCount) || []}
					dataSource={record?.jobRecommendations || []}
					//loadMore={loadMore}
					renderItem={(item) => (
						<List.Item>
							<Card size="small" className="!w-full min-h-[150px]">
								<Checkbox
									value={item.key}
									checked={item.checked}
									className="w-full checkbox-top"
									onChange={(e) => onProductSelected(e, record, item)}
								>
									<Space className='items-start'>
										<Image src={item.logo} preview={false} width={100} />
										<Tooltip title={<><p>{item.description}</p><p>Channel ID: {item.channelid}</p><p>SupplierID: {item.supplierId}</p></>}>
											<InfoCircleOutlined className='text-base' />
										</Tooltip>
									</Space>
									<div className='break-words my-3 text-xs'>
										{item.name + ' '}
									</div>
									{item?.customercontracts && item.customercontracts?.length>0?
									<>
									<div className="break-words">
									{"Credits Available: "}
									</div>
									<div className="break-words">
									{item?.customercontracts[0]?.limitUsed+" used / "+item?.customercontracts[0]?.limitTotal||0}
									</div>
									</>:
									<div className="flex justify-between items-center">
										{item.postingDurationDays + ' Days'}
										<Button size="small">
											{item?.priceCurrencySymbol} {item.buyerPrice}
										</Button>
									</div>}
								</Checkbox>
								{item?.termsUrl&&
									<div className="flex justify-end mt-3">
										<Button
											type="link"
											className="!p-0 !text-[11px] !text-gray-400 hover:!text-gray-500 hover:underline"
											onClick={() =>
												window.open(item.termsUrl, "_blank", "noopener,noreferrer")
											}
										>
											Terms and Conditions
										</Button>
									</div>
								}
							</Card>
						</List.Item>
					)}
				/>
				{!record?.jobRecommendations?.length && (
					<span className="font-bold">No product recommendations found.</span>
				)}
			</>
		);
	};

	//delete selected product
	const DeleteBuyProduct=(record)=>{
		let tempDeleteArray=selectedJobList;
		tempDeleteArray=tempDeleteArray.filter((item)=>!(item.key===record.key&&item.jobId===record.jobId))
		let total=0;
		tempDeleteArray.map((item)=>{
			if(!item?.customercontracts?.length>0){
			total=total+item?.buyerPrice||0
			}
		})
		const hasLinkedInItem = tempDeleteArray.some(
				item => item.header?.toLowerCase().includes('linkedin boost')
			);
		setLinkedInBoost(hasLinkedInItem.toString());
		setSelectedJobList(tempDeleteArray);
		let tempJobData=jobBasketData;
		if(tempJobData?.length>0){
		let index = tempJobData.findIndex(item => item.id === record.id);
		 tempJobData[index]?.jobRecommendations?.map((recommendItem)=>{
				if(recommendItem.key===record.key){
				recommendItem.checked=false
				}
		})
		}
		setJobBasketData(tempJobData)
		setSelectedTotal(total);
	}

	const onSelectRow =(newSelectedRowKeys)=>{
		setSelectedRowKeys(newSelectedRowKeys);
	}
	const onSelectChange = (record, selected) => {
		setJobBasketData(prev =>
			prev.map(job => {
				if (job.id !== record.id) return job;

				return {
					...job,
					jobRecommendations: job.jobRecommendations.map(rec => ({
						...rec,
						checked: selected
					}))
				};
			})
		);
		setSelectedJobList(prev => {
			let updated = [...prev];
			if (selected) {
				const productsToAdd =
					record?.jobRecommendations?.map(item=>({
						...item,
						checked: true,
						title: `${record.title} ${record.reference}`,
						id: record.id,
						buyerId: buyerId,
						place: record.place,
					})) || [];
				productsToAdd.forEach(product => {
					const exists = updated.some(
						item =>
							item.key === product.key &&
							item.jobId === product.jobId
					);
					if (!exists) {
						updated.push(product);
					}
				});
			} else {
				updated = updated.filter(
					item => item.jobId !== record.jobId
				);
			}
			const total = updated.reduce((sum, item) => {
				if (!(item?.customercontracts?.length > 0)) {
					return sum + (item?.buyerPrice || 0);
				}
				return sum;
			}, 0);
			setSelectedTotal(total);
			const hasLinkedInItem = updated.some(
				item => item.header?.toLowerCase().includes('linkedin boost')
			);
			setLinkedInBoost(hasLinkedInItem.toString());
			return updated;
		});
	};

	const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => onSelectChange(selectedRowKeys, selectedRows),
  };

	//Remove all selected products
	const removeSelectedAll=()=>{
		setSelectedJobList([]);
		setLinkedInBoost("false");
		jobBoardBoostsBasketList();
		handleCancel();
	}

	//on Supplir selected
	const onSupplierSeleted=(values)=>{
		setSupplierSelectedList(values)
	}

	const handleCancelTopUp = () => {
    formCreate.resetFields();
    setIsEditModalOpen(false);
  };

	const handleOpenTopupModal = () => {
		setShowCreditInvoiceSuccessMessage(false);
		setIsEditModalOpen(true);
	};

  //Function to save edited job
  //Function to save edited job
	const saveDetails = async (values) => {
		setPurchaseLoader(true);
    let payload = {
      buyerId: buyerId,
      contractAmount: values?.contractAmount,
			invoiceAmount: values?.contractAmount,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      purchaseOrderInfo: values?.orderInfo,
			billingDateStart:moment().format('YYYY-MM-DD'),
			billingDateEnd:moment().format('YYYY-MM-DD'),
      type: paymentType,
      confirmerName : values?.userName,
			freeCredits:paymentType==="free"?true:false,
      doNotInvoice:paymentType==="free"?1:0 
    }
      let method, url, body;
      method = "POST";
      url = WebLinks.AddOrderContractAmountDetails;
      const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
      if (!response.isCatch || response.resultObj.statusCode === "2000") {
        if(paymentType==="card"|| (AllowCreditInvoicing==="false" && isHIAdmin==="false" && !hasSubmittedCreditInvoice)){
          createCheckoutSession(values?.contractAmount,response.resultObj.buyerOrdersId);
          return;
       }else{
				setPurchaseLoader(false);
        commonContext.changeCommonValues({'boostCredits':response.resultObj?.boostCredits||0});
        handleCancel();
        message.success(response.resultObj.message);
       }
      } else {
				setPurchaseLoader(false);
        handleCancel();
        message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };

	const createCheckoutSession = async (amount,buyerOrdersId) => { 
    let payload = {
      buyerId: buyerId,
      amount: amount,
      currency: getCurrencyName(currencyContext.currency),
      productName: "Credit Top Up",
      buyerOrdersId: buyerOrdersId
    }
    let method, url, body;
    method = "POST";
    url = WebLinks.CreateStripeSession;
    const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
			setPurchaseLoader(false);
			window.location.href = response.resultObj.data;
      //message.success(response.resultObj.message);
    } else {
			setPurchaseLoader(false);
      message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };

	// Save LinkedIn URL for buyer
	const saveLinkedIn = async (values) => {
		try {
			const payload = {
				buyerId: buyerId,
				linkedinCompanyURL: values?.linkedURL,
				createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
			};
			const response = await APIUtils.apiCall('PUT', WebLinks.PutLinkedInURL, JSON.stringify(payload));
			if (!response.isCatch && response.resultObj && response.resultObj.statusCode === "2000") {
				setLinkedInUrl(values?.linkedURL);
				message.success(response?.resultObj?.message );
			} else {
				message.error(response?.resultObj?.message || constants.FAILED_SAVE);
			}
		} catch (err) {
			message.error(constants.FAILED_SAVE);
		}
	};

	const handleOpenCreditInvoiceModal = () => {
		setIsCreditInvoiceModalOpen(true);
	};

	const handleCloseCreditInvoiceModal = () => {
		creditInvoiceForm.resetFields();
		setIsCreditInvoiceModalOpen(false);
	};

	const handleSaveCreditInvoice = async (values) => {
		const payload = {
			buyerId: buyerId,
			companyLegalName: values?.companyLegalName,
			companyCity: values?.companyCity||"",
			companyAddress: values?.companyAddress||"",
			companyState: values?.companyState||"",
			companyZip: values?.companyZip||"",
			companyCountry: values?.companyCountry,
			invoiceEmail: values?.invoiceEmail,
			createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
		};
		const response = await APIUtils.apiCall('POST', WebLinks.PostCreditInvoice, JSON.stringify(payload));
			if (!response.isCatch && response.resultObj && response.resultObj.statusCode === "2000") {
				message.success(response?.resultObj?.message );
				if (isSelfService === "true") {
					setHasSubmittedCreditInvoice(true);
					setPaymentType("invoice");
					formCreate.setFieldsValue({ type: "invoice" });
					setOpenTopupAfterCreditInvoiceClose(true);
				}
				handleCloseCreditInvoiceModal();
			} else {
				message.error(response?.resultObj?.message || constants.FAILED_SAVE);
			}
	};
	const handlePaymentTypeChange = (e) => {
		const type = e.target.value;
		setPaymentType(type);
		// Clear amount when switching payment methods
		formCreate.resetFields(['contractAmount']);
	};
	return (
			<Spin spinning={loader} tip="Scanning 3000+ job boards for recommendations...">
				<div>
					<div className="flex justify-end mb-3 text-xs">
						<Space wrap>
						</Space>
					</div>
					<div className="flex justify-between items-center gap-1">
						<Space>
							<div className="uppercase font-bold text-xl">Your Jobs Boost Basket</div>
							<span>{jobsCount} Jobs Listed </span>{props?.buyerId ? <span className='font-bold text'></span> : null}
						</Space>
					</div>
					<Divider className="my-3" />
					<div className="flex flex-wrap justify-between items-center gap-1 mb-3">
						<Space wrap>
							{/* <Button className={recommendTableShow?'warning-btn uppercase font-bold':' uppercase font-bold'} icon={<BulbOutlined />} onClick={()=>{setRecommendTableShow(true);jobBoardBoostsBasketList(true)}}>Recommend Products</Button>
							<span>OR</span> */}
							<Select
								placeholder="Select Job Board Supplier"
								className="w-full md:w-60"
								mode='multiple'
								onChange={(value)=>onSupplierSeleted(value)}
							>
								{/* <Option value="-1">
									<Space>
										Show All
									</Space>
								</Option> */}
								{jobBasketSupplierList?.map((item => {
									return (
										<Option value={item.boostChannelId}>
											<Space>
												{item.name}
											</Space>
										</Option>
									)
								}))}
							</Select>
							<Button className='warning-btn uppercase font-bold' icon={<UnorderedListOutlined />} onClick={()=>{jobBoardBoostsBasketList()}}>Show Products</Button>
						</Space>
						<Button type="primary" disabled={selectedJobList?.length > 0 ? false : true} icon={<DollarOutlined />} onClick={() => openBuyModal()}>Buy selected products</Button>
					</div>
					<div className='overflow-x-auto'>
						{/* {recommendTableShow===false?
						<Table
							size='small'
							rowSelection={{
								// type: 'checkbox',
								// ...rowSelection,
								// selectedRowKeys: selectedRowKeys,
							}}
							pagination={false}
							//loading={loader}
							rowKey="jobId"
							columns={yourJobsBasketColumns}
							dataSource={jobBasketData}
						/>: */}
						<Table
							size='small'
							rowSelection={
								{
								type: 'checkbox',
								hideSelectAll:true,
								selectedRowKeys, // Bind selectedRowKeys to the state variable
								onSelect: onSelectChange, // Handle row selection/deselection
								onChange:onSelectRow,
								// ...rowSelection,
							}}
							rowKey="id"
							pagination={false}
							columns={yourJobsBasketColumns}
							dataSource={jobBasketData}
							className='hide-expand-cell'
						//	loading={loader}
							expandedRowKeys={expandedRowKeys}
							expandable={{
								defaultExpandAllRows: true,
								expandedRowRender,
								expandIcon: () => null,
								expandedRowClassName: 'bg-gray-100'
							}}
						/>
						{/* } */}
						<div className='text-right mt-3'>
							<Button type="primary" icon={<DollarOutlined />} disabled={selectedJobList?.length > 0 ? false : true} onClick={() => openBuyModal()}>Buy selected products</Button>
						</div>
					</div>
					<Modal
						title={"BOOST ORDER"}
						open={showBoostProductBuy}
						onCancel={handleCancel}
						style={{ top: 20 }}
						zIndex={1000}
						width={1000}
						footer={[]}
						destroyOnClose={true}
					>
						<div className='text-right mt-3'>
							<Button className='mr-3' icon={<DeleteOutlined />} onClick={() => removeSelectedAll()}>Remove All</Button>
						</div>
						<Table
							//loading={isLoading}
							size='small'
							columns={boostJobsBuyColumns}
							dataSource={selectedJobList}
							pagination={false}
							showHeader={false}
							summary={() => BuyProductsSummary()}
						/>
						<div className='mt-3'>
							{linkedInBoost==="true"?
							<div>
								{linkedInUrl===null || linkedInUrl===""?
								<span className="text-red-500 italic font-semibold">A LinkedIn Company URL is required to boost on LinkedIn. Please add it before proceeding.</span>
								:null}
								<div className='mb-3 mt-2'>
									<Form form={formCreateLinkedIn} name="form_in_modal" onFinish={saveLinkedIn}>
										<div className="flex items-center gap-2">
											<Form.Item name="linkedURL" className="mb-0 w-full" 
											rules={[
												{ required: true, message: 'Please enter LinkedIn URL' },
												{ type: "url", message: "Please enter a valid LinkedIn Company URL, e.g. https://www.linkedin.com/company/your-company-name" },
												{
													validator: (_, value) => {
														if (!value || value.startsWith("https://")) {
															return Promise.resolve();
														}
														return Promise.reject(
															new Error("Please enter a valid LinkedIn Company URL, e.g. https://www.linkedin.com/company/your-company-name")
														);
													},
												},
											]}
											>
												<Input placeholder="LinkedIn URL" 
												suffix={
													<Tooltip title="Your LinkedIn Company URL is the web address of your company's LinkedIn page, for example: https://www.linkedin.com/company/your-company-name. You can find this by visiting your company page on LinkedIn and copying the URL from your browser.">
														<InfoCircleOutlined className="cursor-pointer text-gray-500 hover:text-blue-500" />
													</Tooltip>
												}
												/>
											</Form.Item>
											<Form.Item className="mb-0">
												<Button type="primary" htmlType="submit" >Save</Button>
											</Form.Item>
										</div>
									</Form>
								</div>
							</div>:null}
						{sessionStorage.getItem('isSelfService')==="true"||sessionStorage.getItem('isBoost')==="true"?
							<span className='font-semibold mt-3'>Boost Credit Balance is:  {commonContext.common.boostCredits} {getCurrencyName(currencyContext.currency)}</span>
							:null}
							<Checkbox className='mt-3' onChange={(e) => { setTermsChecked(e.target.checked) }}> 
								{constants.BOOST_JOB_AD_TERMS_MSG}
								<Typography.Link onClick={() => window.open('/terms-and-conditions', '_blank')}>Terms and Conditions.</Typography.Link>
							</Checkbox>
						</div>
						{sessionStorage.getItem('isSelfService')==="true"||sessionStorage.getItem('isBoost')==="true"?
						<>
						{selectedTotal<=commonContext.common.boostCredits?
						<div className='font-semibold mt-3'>{constants.BOOST_JOB_AD_BUY_TEXT_SELF_SERVICE_1}</div>
						:<div className='font-semibold mt-3'>{constants.BOOST_JOB_AD_BUY_TEXT_SELF_SERVICE_2}<Button type='link' onClick={handleOpenTopupModal}>Top Up Credits</Button></div>}
						</>:
						<div className='font-semibold mt-3'>{constants.BOOST_JOB_AD_BUY_TEXT}</div>}
						<div className='text-right mt-3'>
							<Button className='mr-3' icon={<ArrowLeftOutlined />} onClick={() => handleCancel()}>Change Selection</Button>
							<Button type="primary" disabled={
								linkedInBoost==="true" && (linkedInUrl===null || linkedInUrl==="")?true:
								sessionStorage.getItem('isSelfService')==="true"||sessionStorage.getItem('isBoost')==="true"?!(termsChecked && selectedTotal<=commonContext.common.boostCredits ):(!termsChecked) 
								} 
								icon={<CheckOutlined />} onClick={()=>BookJobsNow()}>Book Now</Button>
						</div>
					</Modal>
				</div>
				<Modal
        title={constants.BuyBoostCredits}
        open={isEditModalOpen}
        onCancel={handleCancelTopUp}
        destroyOnClose
        zIndex={2000}
        //okText={<span className="capitalize">Save</span>}
       // onOk={() => form.submit()}
        style={{ top: 20 }}
        width={800}
        footer={paymentType!==null || AllowCreditInvoicing==="false" ?
          [
          <Button key="cancel" onClick={()=>handleCancelTopUp()}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" loading={purchaseLoader} onClick={()=>formCreate.submit()}>
            PURCHASE
          </Button>,
        ]:[]
      }
      >
        <Form form={formCreate} name="form_in_modal" layout="vertical" onFinish={saveDetails}>
          <div >
            {showCreditInvoiceSuccessMessage && (
              <p className="mb-4 font-semibold">
                Thanks for providing your invoicing details. Please purchase some Top Up Credits
              </p>
            )}
            {AllowCreditInvoicing==="true"?<>
              <Form.Item
                label="Select Payment Type"
                name="type"
              >
								<Radio.Group onChange={handlePaymentTypeChange}>
                    <Radio value="card">Card Payment</Radio>
                    <Radio value="invoice">Invoice</Radio>
                  {Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ? (
                    <Radio value="free">Free Credits</Radio>
                  ):null}
                </Radio.Group>
              </Form.Item>
            </>:
						Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ? 
						<Form.Item
							label="Select Payment Type"
							name="type"
						>
							<Radio.Group onChange={handlePaymentTypeChange}>
									<Radio value="card">Card Payment</Radio>
									<Radio value="free">Free Credits</Radio>
							</Radio.Group>
						</Form.Item>           
					:
						AllowCreditInvoicing==="false" && hasSubmittedCreditInvoice?
					<Form.Item
						label="Select Payment Type"
						name="type"
					>
						<Radio.Group onChange={handlePaymentTypeChange}>
							<Radio value="card">Card Payment</Radio>
							<Radio value="invoice">Invoice</Radio>
							{Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ? (
								<Radio value="free">Free Credits</Radio>
							):null}
						</Radio.Group>
					</Form.Item>
						:AllowCreditInvoicing==="false"?
					<Space>
						<Form.Item
							label="Select Payment Type"
							name="typer"
						>
							<Radio.Group name='radio' defaultValue="card">
									<Radio value="card">Card Payment</Radio>
							</Radio.Group>
						</Form.Item>
						<Form.Item><Button className='mt-7' type="link" onClick={handleOpenCreditInvoiceModal}>Apply for Credit Invoicing</Button></Form.Item>
						</Space>:null}
            {paymentType!==null || AllowCreditInvoicing==="false" ?
            <>
            <Form.Item
              name="contractAmount"
              label={`Credit Amount ${getCurrencyName(currencyContext.currency)}`}
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
                {
                  validator: (_, value) =>
                    value == null || value === "" || Number(value) >= 50
                      ? Promise.resolve()
											: Promise.reject(new Error("Minimum credit amount must be 50.")),
                },
              ]}
            >
              {/* <InputNumber min={0} className='w-full' placeholder="Amount"/> */}
							{(paymentType === "free" || paymentType === "card") ?
              	<InputNumber
									controls={false}
									className="w-full"
									placeholder="Enter amount"
									parser={(value) => value?.replace(/[^\d.]/g, '')}
									onKeyDown={(e) => {
										const allowedKeys = [
											"Backspace","Delete","ArrowLeft","ArrowRight","Tab","Home","End",
										];
										if (
											!/[0-9.]/.test(e.key) &&
											!allowedKeys.includes(e.key) &&
											!(e.ctrlKey || e.metaKey)
										) {
											e.preventDefault();
										}
										// Allow only one decimal point
										if (e.key === "." && e.currentTarget.value.includes(".")) {
											e.preventDefault();
										}
									}}
                />:
							<Select placeholder="Choose amount">
								{options.map((value) => (
									<Option key={value} value={value}>
										{value}
									</Option>
								))}
							</Select>}
            </Form.Item> 
            {paymentType!=="card"?
            <>
            {isHIAdmin==="false"&&AllowCreditInvoicing==="false"&&!hasSubmittedCreditInvoice?null:
            <>
            {paymentType==="invoice"?
						<>    
            <Form.Item name="orderInfo" label="Purchase Order Info. (optional)"
            >
            <Input placeholder='Order Info.'/>
           </Form.Item>
					 <Form.Item name="userName" label="Please enter your name to confirm"
					 >
					 <Input placeholder='Name'/>
					</Form.Item>
					</>
					 :
					 <Form.Item name="orderInfo" label="Purchase Order Info. (optional)"
           >
           <Input placeholder='Order Info.'/>
          </Form.Item>
            }
            </>           
            }
           </>:null}
           </>:null}
          </div>       
        </Form>
      </Modal>
			<Modal
				title="Credit Invoicing Request"
				open={isCreditInvoiceModalOpen}
				afterOpenChange={(open) => {
					if (!open && openTopupAfterCreditInvoiceClose) {
						setShowCreditInvoiceSuccessMessage(true);
						setIsEditModalOpen(true);
						setOpenTopupAfterCreditInvoiceClose(false);
					}
				}}
				onCancel={handleCloseCreditInvoiceModal}
				zIndex={3000}
				footer={[
					<Button key="cancel" onClick={handleCloseCreditInvoiceModal}>Cancel</Button>,
					<Button key="submit" type="primary" onClick={() => creditInvoiceForm.submit()}>Save</Button>,
				]}
				width={700}
			>
				<div className="mb-3">
					<p className="font-semibold mb-2">Please provide your invoicing details to be approved for credit invoicing:</p>
					<p className="text-xs text-gray-500 italic">*All invoices must be settled within the 30 day term or invoicing may be removed.</p>
				</div>
				<Form form={creditInvoiceForm} layout="vertical" onFinish={handleSaveCreditInvoice}>
					<Form.Item
						name="companyLegalName"
						label="Company Legal Name"
						rules={[{ required: true, message: 'Required field' }]}
					>
						<Input />
					</Form.Item>
					<div className="mb-3">
						<div className="mb-2 text-[14px] font-normal text-black-700">Company Address</div>
						<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
						<Form.Item
							name="companyAddress"
							label="Company Address"
							rules={[{ required: true, message: 'Required field' }]}
						>
							<Input.TextArea
    						autoSize={{ minRows: 3, maxRows: 6 }} />
						</Form.Item>
						{getCurrencyName(currencyContext.currency)==="GBP"?
							<Form.Item
								name="companyCity"
								label="Company City"
								rules={[{ required: true, message: 'Required field' }]}
							>
								<Input />
							</Form.Item>:null}
							{getCurrencyName(currencyContext.currency)==="GBP"||getCurrencyName(currencyContext.currency)==="EUR"?null:
							<Form.Item
								name="companyState"
								label="Company State"
								rules={[{ required: true, message: 'Required field' }]}
							>
								<Input />
							</Form.Item>}
							<Form.Item
								name="companyZip"
								label={getCurrencyName(currencyContext.currency)==="GBP"||getCurrencyName(currencyContext.currency)==="EUR"?"Company Postcode":"Company Zip"}
								rules={[{ required: true, message: 'Required field' }]}
							>
								<Input />
							</Form.Item>
							<Form.Item
								name="companyCountry"
								label="Company Country"
								rules={[{ required: true, message: 'Required field' }]}
							>
							<Select 
										//onChange={(e)=>onCountryslect(e)} 
								allowClear 
								showSearch
								loading={countryLoader} 
								placeholder={<span className='text-sm normal-case'>Select Country</span>}  
								className="w-60"
								filterOption={(input, option) =>
										(option?.props?.children ?? '').toLowerCase().includes(input.toLowerCase())
								}
								>
								<Option key="showall" value="showall">Show All</Option>
								<Option key="global" value="global">Global</Option>
								{countryList.map((item) => (
								<Option key={item.countryCode} value={item.countryCode}>{item.country}</Option>
								))}
								</Select>
							</Form.Item>
						</div>
					</div>
					<Form.Item
						name="invoiceEmail"
						label="Invoice Email"
						rules={[
							{ required: true, message: 'Required field' },
							{ type: 'email', message: 'Please enter a valid email address' },
						]}
					>
						<Input />
					</Form.Item>
				</Form>
			</Modal>
		</Spin>
	);
};

export default JobBoardBasketView;